import {useAuthContext} from "../../../Auth/provider/AuthProvider";
import VerticalBox from "../../../../core/components/box/vertical";
import RenderIf from "../../../../core/components/render-if";
import Typo from "../../../../core/components/typo";
import __ from "../../../../core/utils/translate/translate";
import OrganizationCard from "./components/organizationCard";
import {getActiveOrganisation} from "../../../Auth/services/organisationService";
import {useEffect} from "react";
import {useNavigateTo} from "../../../../core/hooks/useNavigate";
import OrganizationChangeCard from "./components/organizationChangeCard";

const ProfileOrganisationView = () => {
    const {organisationList} = useAuthContext();
    const navigateTo = useNavigateTo();
    const activeOrganisationId = getActiveOrganisation()?.id;
    const activeOrganization = getActiveOrganisation();

    // useEffect(() => {
    //     navigateTo('/app/gateway')
    // }, []);
    //
    // return null

    return (
        <>
            <RenderIf cond={activeOrganization}>
                <OrganizationChangeCard/>
                    {/*<OrganizationCard organisation={activeOrganization} />*/}
            </RenderIf>

            <RenderIf cond={false}>
                <VerticalBox
                    withBackground
                    className="rounded-b-3xl shadow-[0px_4px_20px_0px_rgba(0,0,0,0.2)]"
                    containerClassName="p-4 px-8"
                >
                    <div className="relative z-[1] flex w-full flex-col p-2">
                        <Typo weight="semi-bold" className="ui-clamp-3  justify-end">
                            {__("Are you no longer in this organization?")}
                        </Typo>
                        <Typo as="p" className="mb-4" type="secondary">
                            {__("If you want to change your organization, you must leave this organization first. Be aware that when you leave the organization, you will also leave your team and the points you got in the team will be zero.")}
                        </Typo>

                    </div>
                </VerticalBox>
            </RenderIf>
        </>
    );
};

export default ProfileOrganisationView;
